import {CurrentUserDetails} from '../../../common/types';

export enum AuthActionTypes {
  SET_TOKEN = 'SET_TOKEN',
  SET_USER = 'SET_USER',
  LOGOUT = 'LOGOUT',
}

export type SetTokenAction = {
  type: AuthActionTypes.SET_TOKEN,
  payload: string
};

export type SetUserAction = {
  type: AuthActionTypes.SET_USER,
  payload: CurrentUserDetails | null
};

export type LogoutAction = {
  type: AuthActionTypes.LOGOUT,
};

export type AuthAction = SetTokenAction | SetUserAction | LogoutAction;


